module.exports = __webpack_public_path__ + "0bd4b9fb6844bb1841a7a79f35f01bd5.svg";